import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';

interface AdditionalInputField {
  dataType: string;
  required: string;
  detailedDescription?: {
    [locale: string]: string;
  };
}

interface AdditionalInputData {
  [key: string]: AdditionalInputField;
}

@Component({
  selector: "app-additional-data-description-dialog",
  templateUrl:"./additional-data-description-dialog.component.html",
  styleUrls: ["./additional-data-description-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AdditionalDataDescriptionDialogComponent implements OnInit {
  parentForm: FormGroup;
  formParam: string | '';
  additionalData: any | null;
  additionalInputData: any;
  additionalDataForm!: FormGroup;
  isNewPaymentMode: boolean = false;

  creation: boolean = false;
  editing: boolean = false;

  locale: string = localStorage.getItem('locale')!;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<AdditionalDataDescriptionDialogComponent>,
    private fb: FormBuilder,
    private dialog: MatDialog
  ){
    if(this.data) {
      this.parentForm = this.data.parentForm;
      this.formParam = this.data.formParam;
      this.additionalData = this.data.additionalData ?? [
        {
          paymentMode: this.data.additionalInputData ?? null,
          additionalData: this.data.additionalData ?? null
        }
      ];
      this.isNewPaymentMode = this.data?.isNewPaymentMode ?? false;
      this.additionalInputData =
        this.data.additionalInputData ||
        this.additionalData?.[0]?.paymentMode?.additionalInputData;
      this.creation = this.data.creation ?? false;
      this.editing = this.data?.editing ?? false;
    }
  }

  ngOnInit(): void {
    this.createAdditionalDataForm();
  }

  createAdditionalDataForm(){
    const additionalInputData = this.additionalData?.[0]?.paymentMode?.additionalInputData || this.additionalInputData;
    const additionalData = this.additionalData?.[0]?.additionalData ?? null;
    this.buildAdditionalDataForm(additionalInputData, additionalData);

    const canEnable = this.creation || this.isNewPaymentMode;

    if (canEnable) {
      this.additionalDataForm.enable({ emitEvent: false });
    } else {
      this.additionalDataForm.disable({ emitEvent: false });
    }
  }

  buildAdditionalDataForm(
    additionalInputData?: AdditionalInputData,
    additionalData?: { [key: string]: string }
  ) : void {
    this.additionalDataForm = this.fb.group({});

    if(additionalInputData) {
      this.additionalInputData = additionalInputData;
      
      Object.keys(additionalInputData).forEach((key) => {
        const controlConfig = additionalInputData[key];

        const validators = [];
        if(controlConfig.required) {
          validators.push(Validators.required);
        }
        if(controlConfig.dataType === 'numeric') {
          validators.push(Validators.pattern('^[0-9]*$'))
        }

        const label = 
          controlConfig?.detailedDescription?.[this.locale] ||
          controlConfig?.detailedDescription?.['en-en'];
        
        const value = additionalData?.[key] || additionalData?.[label] || '';

        const control = this.fb.control(value, validators);

        this.additionalDataForm.addControl(key, control);
      })
    }
  }

  setAdditionalDataLabels(keyMop: string): string {
    const paymentMode = this.additionalData[0]?.paymentMode;
    
    if(!paymentMode){
      return keyMop;
    }

    const additionalInputDataEntries = Object.entries(paymentMode?.additionalInputData || {});
    const entry = additionalInputDataEntries.find(([key]) => key === keyMop);
    let obj: any;

    if(entry) {
      [, obj] = entry;
      if(obj.detailedDescription && obj.detailedDescription[this.locale]){
        return obj.detailedDescription[this.locale];
      }
    }

    return keyMop;
  }

  isFieldRequired(key: string): boolean {
    return !!this.additionalInputData?.[key]?.required;
  }

  get hasAdditionalDataFields(): boolean {
    return Object.keys(this.additionalDataForm?.controls || {}).length > 0;
  }

  get hasAdditionalDataValues(): boolean {
    return Object.values(this.additionalDataForm?.controls || {}).some((control: any) => {
      const value = control.value;
      return value !== null && value !== undefined && value !== '';
    });
  }
  
  close() {
    this.dialogRef.close();
  }

  confirmDialog() {
    if (this.additionalDataForm.valid) {
      this.dialogRef.close(this.additionalDataForm.value);
    } else {
      this.additionalDataForm.markAllAsTouched();
    }
  }
}